define([
    'lodash',
    'coreUtils'
], function (_, coreUtils) {
    'use strict';

    const setFixedLayoutProps = pageStructure => {
        _.unset(pageStructure, 'layout.width'); // eslint-disable-line santa/no-side-effects
        return _.set({}, 'content.structure.layout.width', 980);
    };

    return {
        serialize: ({pagesData}) => ({
            pages: _(pagesData).omit(coreUtils.siteConstants.MASTER_PAGE_ID)
                .mapValues((page, pageId) => setFixedLayoutProps(pagesData[pageId].structure)).value()
        }),
        deserialize: _.noop,
        getEncryptedPaths: () => []
    };
});